import { render, staticRenderFns } from "./ProfileSidebarAvailability.vue?vue&type=template&id=5dfc3058&scoped=true"
import script from "./ProfileSidebarAvailability.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProfileSidebarAvailability.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./ProfileSidebarAvailability.vue?vue&type=style&index=0&id=5dfc3058&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dfc3058",
  null
  
)

export default component.exports